<template>
    <BaseFormSchedule 
        :formContext="formContext"
        :edit="false"
    />
</template>

<script>
import handleErrorsService from '@/views/custom-pages/Campanhas/RegisterCampanha/Forms/Services/HandleErrors';
import BaseFormSchedule from './BaseFormSchedule.vue';

import scheduleService from '../Services/ScheduleCampaignService';

export default {
    components: {
        BaseFormSchedule
    },

    props: {
        modalShow: {
            required: true,
            type: Boolean,
        },
        idCampaign: {
            required: true,
            type: Number|null,
        },
        term: {
          required: false,
        },
    },

    data() {
        return {
            formContext: this,
            showScheduleModal: this.$props.modalShow,
            createdCampaign: this.$props.idCampaign,
            termSelected: this.$props.term,
            disabledFieldEdit: {
                adhesionStartDate: false,
                adhesionEndDate: false,

                vaccinationStartDate: false
            },
            form: {
                startDateAdesao: null,
                endDateAdesao: null,
                startTimeAdesao: null,
                endTimeAdesao: null,
                startDateVacinacao: null,
                endDateVacinacao: null,
                startTimeVacinacao: null,
                endTimeVacinacao: null,
                file:null,
                errorApi: {
                    vacinacao: {
                        data_inicio: '',
                        hora_inicio: '',
                        data_termino: '',
                        hora_termino: '',
                    },
                    adesao: {
                        data_inicio: '',
                        hora_inicio: '',
                        data_termino: '',
                        hora_termino: '',
                    },
                    error: null
                }
            },
            errorSchedule: null,
            savingSchedule: false,
            loadingSchedule: false
        }
    },

    methods: {
        closeModal() {
            this.$emit('closeModalSchedule', false);
        },

        cancelScheduleCampaign() {
            this.$emit('canceledScheduleCampaign');
            handleErrorsService.cleanErrors(this.form.errorApi);
        },

        saveScheduledCampaign() {
            const dataSchedule = scheduleService.prepareDataSchedule(this.form);

            if(!dataSchedule) { return; }

            this.savingSchedule = true;
            this.errorSchedule = null;

            this.$http.post(this.$api.campanhaCronograma(this.createdCampaign), dataSchedule).then(() => {
                this.closeModal();
                this.$emit('savedSchedule');
                this.savingSchedule = false;
                handleErrorsService.cleanErrors(this.form.errorApi);
            }).catch(({ response: { data } }) => {
                handleErrorsService.handleErrosLancamento(data, this.form.errorApi);
                this.savingSchedule = false;
            });
        }
    },

    watch: {
        modalShow(newValue) {
            this.showScheduleModal = newValue;
        },

        idCampaign(idCampaign) {
            this.createdCampaign = idCampaign;
        },

        term(term) {
          this.termSelected = term
        }
    }
}
</script>
